<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M5.18638 3.83478C5.55684 3.58723 5.94584 3.37253 6.34889 3.19203C7.49212 2.68006 8.06373 2.42407 8.82422 2.91673C9.58464 3.40941 9.58464 4.21758 9.58464 5.83391V7.08391C9.58464 8.65523 9.58464 9.4409 10.0728 9.92907C10.561 10.4172 11.3466 10.4172 12.918 10.4172H14.168C15.7843 10.4172 16.5925 10.4172 17.0851 11.1777C17.5778 11.9382 17.3218 12.5097 16.8098 13.653C16.6293 14.0561 16.4146 14.4451 16.1671 14.8155C15.2972 16.1174 14.0608 17.1321 12.6142 17.7313C11.1676 18.3305 9.57589 18.4872 8.04018 18.1818C6.5045 17.8763 5.09388 17.1223 3.98671 16.0152C2.87955 14.908 2.12555 13.4974 1.82009 11.9617C1.51462 10.426 1.6714 8.83423 2.2706 7.38766C2.86979 5.94108 3.88449 4.70467 5.18638 3.83478Z"
      fill="currentColor"
    />
    <path
      d="M17.873 5.89101C17.1965 4.17376 15.8277 2.80499 14.1105 2.12848C12.8259 1.62241 11.668 2.78613 11.668 4.16685V7.50018C11.668 7.96041 12.0411 8.3335 12.5013 8.3335H15.8346C17.2154 8.3335 18.3791 7.17562 17.873 5.89101Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'ReportsIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>